import { ApiError } from '@src/@data/api/ApiError';
import { AxiosResponse, isAxiosError } from 'axios';

export function handleResponse<T>(response: AxiosResponse<T>) {
  return response.data;
}

export const handleResponseError = function (error: unknown) {
  if (!isAxiosError(error) || error?.response?.status === 401) {
    throw error;
  }
  const message = error?.response?.data?.message || undefined;
  throw new ApiError(error?.code, message);
};
